import { render, staticRenderFns } from "./DeliveryGroupSeparator.vue?vue&type=template&id=4c450b6d&scoped=true"
import script from "./DeliveryGroupSeparator.vue?vue&type=script&lang=js"
export * from "./DeliveryGroupSeparator.vue?vue&type=script&lang=js"
import style0 from "./DeliveryGroupSeparator.vue?vue&type=style&index=0&id=4c450b6d&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c450b6d",
  null
  
)

export default component.exports